module.exports = __webpack_public_path__ + "img/retailISix.cd97f114.png";